import { useEffect, useState } from 'react'

// xl: '1440px'
// lg: '1280px',
// ml: '1000px',
// md: '600px',
// sm: '375px',
// xs: '360px',

type Breakpoint = 'xl' | 'lg' | 'ml' | 'md' | 'sm' | 'xs'

const useTailwindBreakpoint = (): {
  breakpoint: Breakpoint
  isMobile: boolean
} => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>('lg')

  useEffect(() => {
    const handleResize = () => {
      if (window.screen.width >= 1440) {
        setBreakpoint('xl')
      } else if (window.screen.width >= 1280) {
        setBreakpoint('lg')
      } else if (window.screen.width >= 1000) {
        setBreakpoint('ml')
      } else if (window.screen.width >= 600) {
        setBreakpoint('md')
      } else if (window.screen.width >= 375) {
        setBreakpoint('sm')
      } else {
        setBreakpoint('xs')
      }
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const isMobile = breakpoint === 'xs' || breakpoint === 'sm'

  return { breakpoint, isMobile }
}

export default useTailwindBreakpoint
